import React from "react";
import "./APKsLoader.css";

const APKsLoader = ({ count = 4 }) => {
  return (
    <div className="apks-loader-container">
      <div className="apks-loader-grid">
        {Array.from({ length: count }).map((_, index) => (
          <div key={index} className="apk-skeleton-card">
            <div className="skeleton-header">
              <div className="skeleton-image"></div>
            </div>
            <div className="skeleton-body">
              <div className="skeleton-title"></div>
              <div className="skeleton-subtitle"></div>
              <div className="skeleton-button"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default APKsLoader;
